import React from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import { observer, inject } from "mobx-react";
import { Redirect, Link } from "react-router-dom";
import { checkAuth } from "../../../utils/security";
import SideBar from "../../comum/components/SideBar";
import { IconeCarregar,IconeGenerico } from "../../comum/components/Icones";
import Hero from "../components/Hero";
import TopBar from "../../comum/components/TopBar";
import { httpGet } from "../../../services/geral/BaseService";
import lscache from 'lscache'

@inject("store")
@observer
export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.appStore = this.props.store.appStore;
    this.controller = this.props.store.loginStore;
    this.validacaoStore = this.props.store.validacaoStore;

    this.ImgRigSrc = '/images/_/assets/images/RIG/popup.png';
    this.ImgSsaSrc = '/images/_/assets/images/SSA/popup.png';

    this.state = {
      logging: false,
      modalPopup: false,
      ImgSsaExists: false,
      ImgRigExists: false,
      email: lscache.get('Email') || ''
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.salvarSenha = this.salvarSenha.bind(this);
  }

  componentDidMount() {
    if (this.appStore.width < 768) {
      this.appStore.sidebarFechado = true;
    }
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    this.controller.setMessagemErro();
    // Para tirar o login "automático" basta remover o código abaixo
    //.controller.setUsuario('b2b@tecons.com.br')
    //this.controller.setSenha('inicial')
    //teste de push
    
    fetch(this.ImgRigSrc, { method: 'HEAD' }).then(res => {
      if(res.ok) this.setState({ ImgRigExists: true });
    })
    fetch(this.ImgSsaSrc, { method: 'HEAD' }).then(res => {
      if(res.ok) this.setState({ ImgSsaExists: true });
    })
  }

  updateWindowDimensions() {
    this.appStore.width = window.innerWidth;
  }

  renderFormAcessar = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 0 ? (
          <form
            onSubmit={(event) => this.controller.validaLogin(event)}
            className="login--form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">
                {process.env.rig && "Usuário"}
                {process.env.ssa && "E-mail"}
              </Label>
              <Input
                className="noneCase"
                value={this.controller.usuario}
                onChange={(event) => {
                  this.controller.setUsuario(event.target.value);
                }}
                placeholder=""
                style={{ marginRight: "none" }}
                required="required"
              />
            </FormGroup>
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">Senha</Label>
              <Input
                className="noneCase"
                value={this.controller.senha}
                onChange={(event) =>
                  this.controller.setSenha(event.target.value)
                }
                type="password"
                placeholder=""
                required="required"
                style={{ marginRight: 0 }}
              />
            </FormGroup>
            {this.controller.mensagemErro !== "" && (
              <p style={{ color: "red" }}>{this.controller.mensagemErro}</p>
            )}
            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              disabled={this.controller.logging}
            >
              {this.controller.logging ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Acessar minha conta"
              )}
            </Button>
            <Label className="login--form-label mt-2">
              Esqueceu a senha?{" "}
              <a onClick={() => this.controller.setStatus(1)}> Clique aqui.</a>
            </Label>
            {this.controller.mostrarRedefinirSenha && (
              <Label className="login--form-label mt-2">
                Clique aqui para redefinir a sua senha:{" "}
                <a onClick={() => this.controller.setStatus(3)}>
                  {" "}
                  Redefinir senha.
                </a>
              </Label>
            )}
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  salvarSenha = async (e) => {
    e.preventDefault();
    await this.controller.salvarSenhaAnonimo();
  };

  renderFormRedefinir = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 3 ? (
          <form onSubmit={(e) => this.salvarSenha(e)} className="login--form">
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">Senha atual</Label>
              <Input
                className="noneCase"
                value={this.controller.senhaAtual}
                onChange={(event) =>
                  this.controller.setSenhaAtual(event.target.value)
                }
                type="password"
                placeholder=""
                required="required"
                style={{ marginRight: 0 }}
              />
            </FormGroup>
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">Senha nova</Label>
              <Input
                className="noneCase"
                value={this.controller.novaSenha}
                onChange={(event) =>
                  this.controller.setNovaSenha(event.target.value)
                }
                type="password"
                placeholder=""
                required="required"
                style={{ marginRight: 0 }}
              />
            </FormGroup>
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">Confirmar senha nova</Label>
              <Input
                className="noneCase"
                value={this.controller.confirmaSenha}
                onChange={(event) =>
                  this.controller.setConfirmaSenha(event.target.value)
                }
                type="password"
                placeholder=""
                required="required"
                style={{ marginRight: 0 }}
              />
            </FormGroup>
            {this.controller.msgSenha !== "" && (
              <p style={{ color: "red" }}>{this.controller.msgSenha}</p>
            )}
            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              disabled={
                this.controller.alterandoSenha ||
                this.controller.desabilitaRedefinirSenha
              }
            >
              {this.controller.alterandoSenha ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Redefinir Senha"
              )}
            </Button>
            <Button
              size="lg"
              block
              onClick={() => this.controller.setStatus(0)}
              className="action-btn-secondary"
            >
              Cancelar
            </Button>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormRecuperar = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 1 ? (
          <form
            onSubmit={(event) => this.controller.RecuperarSenha(event)}
            className="login--form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <Label className="login--form-label">
                Informe e-mail para recuperar a senha
              </Label>
              <Input
                className="noneCase"
                value={this.controller.emailRecuperar}
                onChange={(event) => {
                  this.controller.setEmailRecuperar(event.target.value);
                }}
                placeholder=""
                style={{ marginRight: "none" }}
                required="required"
              />
            </FormGroup>
            {this.controller.mensagemErroRecuperar !== "" && (
              <p style={{ color: "red" }}>
                {this.controller.mensagemErroRecuperar}
              </p>
            )}
            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              disabled={this.controller.logging}
            >
              {this.controller.logging ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Redefinir Senha"
              )}
            </Button>
            <Button
              size="lg"
              block
              onClick={() => this.controller.setStatus(0)}
              className="action-btn-secondary"
            >
              Cancelar
            </Button>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormMFA = () => {
    const pendingLogin = lscache.get("PendingLogin");
    const statusMFA = pendingLogin && pendingLogin.StatusMFA; // compatível com qualquer Babel

    return (
      <React.Fragment>
        {this.controller.statusAcessar === 4 ? (
          <form
            //onSubmit={(event) => this.controller.RecuperarSenha(event)}
            className="login--form mfa-form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <h4 className="title-black">
                Confirme sua identidade
              </h4>
              <Label className="login--form-label label-tight">
                Para melhorar a segurança no seu acesso, precisamos confirmar sua identidade.
              </Label>
            </FormGroup>
            {this.controller.mensagemErroRecuperar !== "" && (
              <p style={{ color: "red" }}>
                {this.controller.mensagemErroRecuperar}
              </p>
            )}

            {(statusMFA === "2" || statusMFA === "3") && (
              <Button
                size="lg"
                block
                onClick={() => {
                  this.controller.setStatus(6);
                  this.controller.startResendTimer();
                  this.controller.handleSendSMS();
                }}
                className="action-btn-mfa d-flex justify-content-start align-items-center"
              >
                <IconeGenerico icone="mobile" tamanho="sm" style={{ marginRight: "8px" }} />
                <span style={{ marginLeft: 5 }}>Receber código por SMS</span>
              </Button>
            )}


            <Button
              size="lg"
              block
              onClick={async () => {
                this.controller.setStatus(7);
                await this.controller.handleSendEmail(); 
                this.controller.startResendTimer();
              }}
              className="action-btn-mfa d-flex justify-content-start align-items-center"
            >
              <IconeGenerico icone="envelope" tamanho="sm" style={{ marginRight: "2px" }} />
              <span style={{ marginLeft: 5 }}>Receber código por e-mail</span>
            </Button>

            <Label className="login--form-label">
              {" "}
              <a onClick={() => this.controller.setStatus(0)}>
                {" "}
                Voltar
              </a>
            </Label>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormSMS = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 6 ? (
          <form
            onSubmit={(event) => this.controller.handleConfirmar(event)}
            className="login--form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <h4 className="title-black">
                Confirme sua identidade
              </h4>
              <Label className="label-tight mt-2">
                Enviamos um código por SMS para
              </Label>
              <Label className="label-tight">
                {this.controller.getPhone()}
              </Label>
              <Label className="label-tight">
                <a onClick={() => this.controller.setStatus(4)}>
                  {" "}
                  Voltar
                </a>
              </Label>

              <div className="mt-4">
                <div className="d-flex justify-content-center gap-2">
                  {this.controller.otp.map((valor, index) => (
                    <Input
                      key={index}
                      type="text"
                      maxLength="1"
                      value={valor}
                      onChange={(e) => this.controller.handleOtpChange(e.target.value, index)}
                      onKeyDown={(e) => this.controller.handleOtpKeyDown(e, index)}
                      onPaste={(e) => this.controller.handleOtpPaste(e)}
                      innerRef={(el) => (this.controller.inputsRef[index] = el)}
                      className="text-center"
                      style={{ width: "50px", fontSize: "24px" }}
                    />
                  ))}
                </div>

                <Label className="login--form-label mt-2 d-flex justify-content-between">
                  <a
                    onClick={() => {
                      if (this.controller.canResend) {
                        this.controller.startResendTimer(),
                        this.controller.handleSendSMS();
                      }
                    }}
                    style={{ pointerEvents: this.controller.canResend ? "auto" : "none", opacity: this.controller.canResend ? 1 : 0.5 }}
                  >
                    Reenviar código
                  </a>

                  <span>
                    {this.controller.canResend
                      ? ""
                      : `Aguarde 00:${String(this.controller.resendTimer).padStart(2, "0")}`}
                  </span>
                </Label>

              </div>


            </FormGroup>
            {this.controller.mensagemErroRecuperar !== "" && (
              <p style={{ color: "red" }}>
                {this.controller.mensagemErroRecuperar}
              </p>
            )} 


            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              disabled={this.controller.logging}
            >
              {this.controller.logging ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Confirmar"
              )}
            </Button>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormEmail = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 7 ? (
          <form
            onSubmit={(event) => this.controller.handleConfirmar(event)}
            className="login--form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <h4 className="title-black">
                Confirme sua identidade
              </h4>
              <Label className="label-tight mt-2">
                Enviamos um código para o seu e-mail.
              </Label>
              <Label className="label-tight">
                {this.controller.getEmail()}
              </Label>
              <Label className="label-tight">
                <a onClick={() => this.controller.setStatus(4)}>
                  {" "}
                  Voltar
                </a>
              </Label>

              <div className="mt-4">
                <div className="d-flex justify-content-center gap-2">
                  {this.controller.otp.map((valor, index) => (
                    <Input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={valor}
                    onChange={(e) => this.controller.handleOtpChange(e.target.value, index)}
                    onKeyDown={(e) => this.controller.handleOtpKeyDown(e, index)}
                    onPaste={(e) => this.controller.handleOtpPaste(e)} 
                    innerRef={(el) => (this.controller.inputsRef[index] = el)}
                    className="text-center"
                    style={{ width: "50px", fontSize: "24px" }}
                  />
                  ))}
                </div>

                <Label className="login--form-label mt-2 d-flex justify-content-between">
                  <a
                    onClick={() => {
                      if (this.controller.canResend) {
                        this.controller.startResendTimer(),
                        this.controller.handleSendEmail(); 
                      }
                    }}
                    style={{ pointerEvents: this.controller.canResend ? "auto" : "none", opacity: this.controller.canResend ? 1 : 0.5 }}
                  >
                    Reenviar código
                  </a>

                  <span>
                    {this.controller.canResend
                      ? ""
                      : `Aguarde 00:${String(this.controller.resendTimer).padStart(2, "0")}`}
                  </span>
                </Label>

              </div>


            </FormGroup>
            {this.controller.mensagemErroRecuperar !== "" && (
              <p style={{ color: "red" }}>
                {this.controller.mensagemErroRecuperar}
              </p>
            )} 


            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              disabled={this.controller.logging}
            >
              {this.controller.logging ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Confirmar"
              )}
            </Button>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormMFAFirstTime = () => { 
    return (
      <React.Fragment>       
        {this.controller.statusAcessar === 8 ? (
          <form
            className="login--form"
          >
            <FormGroup className="login--form-group form-group has-feedback">
              <h4 className="title-black d-flex align-items-center gap-2">
                <IconeGenerico icone="security triangule" tamanho="sm" className="text-warning me-2" />
                 Segurança atualizada
              </h4>
              <Label className="label-tight mt-2">
                <span><strong>Antes de acessar o sistema</strong>, vamos confirmar sua identidade.
                Enviaremos um <strong>código de 6 dígitos</strong> para o seu e-mail cadastrado.</span>
              </Label>

              <Label className="label-tight title-black mt-2 d-inline-flex align-items-center gap-2 px-2 py-1 border rounded" 
                    style={{
                      borderColor: "#555",       
                      color: "#555",               
                      backgroundColor: "#f5f5f5",  
                      fontSize: "0.7rem"           
                    }}>
                <IconeGenerico icone="envelop" tamanho="sm" className="me-1" />
                {this.controller.getEmail()}
              </Label>

              <Label className="mt-2">
                • O código expira em <strong>5 minutos.</strong>
              </Label>
              <Label className="label-tight">
                • Verifique a <strong>pasta spam.</strong>
              </Label>



            </FormGroup>
            {this.controller.mensagemErroRecuperar !== "" && (
              <p style={{ color: "red" }}>
                {this.controller.mensagemErroRecuperar}
              </p>
            )} 


            <Button
              size="lg"
              block
              type="submit"
              className="action-btn"
              onClick={() => {
                this.controller.setStatus(7);
                this.controller.handleSendEmail();
                this.controller.startResendTimer();
              }}

              disabled={this.controller.logging}
            >
              {this.controller.logging ? (
                <IconeCarregar cor="#fff" />
              ) : (
                "Começar"
              )}
            </Button>
            <Label className="label-tight text-center">
              <a onClick={() => this.controller.setStatus(0)} className="cursor-pointer">
                Voltar
              </a>
            </Label>

          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  renderFormSucesso = () => {
    return (
      <React.Fragment>
        {this.controller.statusAcessar === 2 ? (
          <form onSubmit={() => {}} className="login--form">
            <FormGroup className="login--form-group form-group has-feedback">
              <h4 className="text-justificado">
                {this.controller.mensagemErroRecuperar}
              </h4>
            </FormGroup>
            <Button
              size="lg"
              block
              onClick={() => this.controller.setStatus(0)}
              className="action-btn"
            >
              Login
            </Button>
          </form>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  };

  toggle = () => this.setState({ modalPopup: !this.state.modalPopup });

  popup = () => {
    if (process.env.ssa && this.state.ImgSsaExists) {
      return (
        <Modal
          isOpen={this.state.modalPopup}
          toggle={this.toggle}
          keyboard={true}
          size="lg"
          centered={true}
        >
          <ModalBody>
            <img src={this.ImgSsaSrc} alt="Popup" className="img-fluid" />
          </ModalBody>
        </Modal>
      );
    } else if (process.env.rig && this.state.ImgRigExists) {
      return (
        <Modal
          isOpen={this.state.modalPopup}
          toggle={this.toggle}
          keyboard={true}
          size="lg"
          centered={true}
        >
          <ModalBody>
            <img src={this.ImgRigSrc} alt="Popup" className="img-fluid" />
          </ModalBody>
        </Modal>
      );
    }
  };

  render() {
    if (checkAuth()) {
      if (window.localStorage.getItem('nextPage') != null) {
        return <Redirect to={window.localStorage.getItem('nextPage')} />;
      } else{
        return <Redirect to="/" />;
      }
    } else {
      return (
        <div
          className={
            process.env.rig ? "login-background-rig" : "login-background-ssa"
          }
        >
          <TopBar></TopBar>
          <SideBar />
          <div
            className={`login-container login-container${
              this.appStore.sidebarFechado ? "--fechado" : "--aberto"
            }`}
          >
            {this.popup()}
            <Hero />
            <div className="panel">
              <div className="login--panel-body">
                <div className="login">
                  {(this.controller.statusAcessar === 0 || this.controller.statusAcessar === 1 || 
                    this.controller.statusAcessar === 2 || this.controller.statusAcessar === 3) && (
                    <h4 className="login--panel-header">
                      Acessar <span className="divider"> | </span>
                      <Link to="./controle-acesso">
                        <span className="cadastrar">Cadastre-se</span>
                      </Link>
                    </h4>
                  )}
                  {this.renderFormMFA()}
                  {this.renderFormAcessar()}
                  {this.renderFormRecuperar()}
                  {this.renderFormRedefinir()}
                  {this.renderFormSucesso()}
                  {this.renderFormSMS()}
                  {this.renderFormEmail()}
                  {this.renderFormMFAFirstTime()}
                </div>
              </div>
            </div>
          </div>
          <p className="text-center" style={{ marginBottom: "0" }}>
            &copy; 2019 - WilsonsSons
          </p>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/tela/Login.js